export default __webpack_public_path__ + "static/media/akg.c88788f9.jpg";